import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AuthContainer } from "../../container/AuthLayout.styled";
import {
  FormError,
  FormWrapper,
  AuthButton,
  AuthForm,
  AuthInput,
  AuthRedirectText,
  AuthHeader,
} from "../Auth.styled";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../feature/auth/AuthActions";
import { clearMessage } from "../../feature/message/messageSlice";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import ReactLoading from "react-loading";

const Register = () => {
  // const minUserChar = 6

  const { loading, success } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);
  const { inputError } = useSelector((state) => state.inputError);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const referral = query.get("referral");

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(clearInputError());
  }, [dispatch]);

  useEffect(() => {
    success && navigate("/login");
  }, [navigate, success]);

  const initialValues = {
    username: "",
    email: "",
    password1: "",
    password2: "",
    referral: referral || "",
  };

  const onSubmit = (values) => {
    dispatch(registerUser(values));
  };

  const validationSchema = Yup.object({
    username: Yup.string()
      // .min(minUserChar, `Username must be ${minUserChar}`)
      .required("Username is required")
      .matches(/^\S*$/, "Username cannot contain spaces"),
    email: Yup.string().email().required("Email is required"),
    password1: Yup.string().required("Password1 is required"),
    password2: Yup.string()
      .required("Repeat Password is Required")
      .oneOf([Yup.ref("password1"), null], "Password Must Match"),
    referral: Yup.string().min(6).max(6).required("Referral code is required"),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <AuthContainer>
      <AuthHeader>Create Account</AuthHeader>
      <svg
        width="431"
        height="109"
        viewBox="0 0 431 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: "100%", marginBlock: "-100px 40px" }}
      >
        <path
          d="M1 40L61.8511 106L84.8875 11.5L168.34 64.5L220.933 40L243.97 106L295.258 2L375.669 91L430 75.5"
          stroke="#7B36EE"
          stroke-width="2"
        />
      </svg>
      <AuthForm onSubmit={formik.handleSubmit}>
        {message && <FormError>{message}</FormError>}
        <FormWrapper>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginInlineEnd: "-20px" }}
          >
            <path
              d="M14.1583 14V12.6667C14.1583 11.9594 13.86 11.2811 13.329 10.781C12.7979 10.281 12.0777 10 11.3267 10H5.66333C4.91233 10 4.19208 10.281 3.66104 10.781C3.13 11.2811 2.83167 11.9594 2.83167 12.6667V14"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.495 7.33333C10.0589 7.33333 11.3267 6.13943 11.3267 4.66667C11.3267 3.19391 10.0589 2 8.495 2C6.93111 2 5.66333 3.19391 5.66333 4.66667C5.66333 6.13943 6.93111 7.33333 8.495 7.33333Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <AuthInput
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            type="text"
            name="username"
            placeholder="Username"
            onChange={formik.handleChange}
            value={formik.values.username}
          />
        </FormWrapper>
        <>
          {formik.errors.username ? (
            <FormError>{formik.errors.username}</FormError>
          ) : null}
          <FormError>
            {inputError !== undefined
              ? inputError.username
                ? inputError.username
                : null
              : null}
          </FormError>
        </>
        <FormWrapper>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginInlineEnd: "-20px" }}
          >
            <path
              d="M2.12329 3.5H14.8632V12C14.8632 12.1326 14.8073 12.2598 14.7078 12.3536C14.6082 12.4473 14.4732 12.5 14.3324 12.5H2.65412C2.51334 12.5 2.37832 12.4473 2.27877 12.3536C2.17922 12.2598 2.12329 12.1326 2.12329 12V3.5Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.8632 3.5L8.49326 9L2.12329 3.5"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <AuthInput
            type="email"
            name="email"
            placeholder="email"
            onChange={formik.handleChange}
            value={formik.values.email}
          />
        </FormWrapper>
        <>
          {formik.errors.email ? (
            <FormError>{formik.errors.email}</FormError>
          ) : null}
          <FormError>
            {inputError !== undefined
              ? inputError.email
                ? inputError.email
                : null
              : null}
          </FormError>
        </>
        <FormWrapper>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginInlineEnd: "-20px" }}
          >
            <path
              d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              opacity="0.5"
              d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
              fill="white"
            />
          </svg>
          <AuthInput
            type="password"
            name="password1"
            placeholder="Password"
            onChange={formik.handleChange}
            value={formik.values.password1}
          />
        </FormWrapper>
        <>
          {formik.errors.password1 ? (
            <FormError>{formik.errors.password1}</FormError>
          ) : null}
          <FormError>
            {inputError !== undefined
              ? inputError.non_field_errors
                ? inputError.non_field_errors
                : null
              : null}
          </FormError>
          <FormError>
            {inputError !== undefined
              ? inputError.password1
                ? inputError.password1
                : null
              : null}
          </FormError>
        </>
        <FormWrapper>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginInlineEnd: "-20px" }}
          >
            <path
              d="M5.82301 7.67705C5.43757 6.71565 5.3959 5.65066 5.70504 4.66209C6.01418 3.67352 6.65516 2.822 7.51965 2.25148C8.38414 1.68095 9.4191 1.4264 10.4496 1.53087C11.4801 1.63533 12.4429 2.09239 13.1753 2.8248C13.9077 3.55721 14.3648 4.52004 14.4693 5.55054C14.5737 6.58103 14.3192 7.616 13.7486 8.48048C13.1781 9.34497 12.3266 9.98595 11.338 10.2951C10.3494 10.6042 9.28446 10.5625 8.32307 10.1771L8.32311 10.177L7.50012 11H6.00012V12.5H4.50012V14H2.00012V11.5L5.82312 7.677L5.82301 7.67705Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              opacity="0.5"
              d="M11.25 5C11.3881 5 11.5 4.88807 11.5 4.75C11.5 4.61193 11.3881 4.5 11.25 4.5C11.1119 4.5 11 4.61193 11 4.75C11 4.88807 11.1119 5 11.25 5Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.25 5.375C11.5952 5.375 11.875 5.09518 11.875 4.75C11.875 4.40482 11.5952 4.125 11.25 4.125C10.9048 4.125 10.625 4.40482 10.625 4.75C10.625 5.09518 10.9048 5.375 11.25 5.375Z"
              fill="white"
            />
          </svg>
          <AuthInput
            type="password"
            name="password2"
            placeholder="Re-enter Password"
            onChange={formik.handleChange}
            value={formik.values.password2}
          />
        </FormWrapper>
        {formik.errors.password2 ? (
          <FormError>{formik.errors.password2}</FormError>
        ) : null}
        <FormWrapper>
          <AuthInput
            type="text"
            name="referral"
            placeholder="Referral Code"
            onChange={formik.handleChange}
            value={formik.values.referral}
          />
        </FormWrapper>
        <>
          {formik.errors.referral ? (
            <FormError>{formik.errors.referral}</FormError>
          ) : null}
        </>
        <AuthButton type="submit" disabled={loading}>
          {loading ? (
            <ReactLoading
              type={"spinningBubbles"}
              height={"20px"}
              width={"20px"}
            />
          ) : (
            "Create Account"
          )}
        </AuthButton>
        <AuthRedirectText>
          Already have an account? <Link to="/login">Login</Link>
        </AuthRedirectText>
      </AuthForm>
    </AuthContainer>
  );
};

export default Register;
